export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
